module.exports = __webpack_public_path__ + "static/media/Frame.f6b7bbaa.png";